// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * HTTP参数来源枚举 枚举类
 * HTTP参数来源枚举
 */
export enum EnumHTTPParameterSource {
  /** Query : URL地址参数 */
  Query = 1,
  /** Body : HTTP Body */
  Body = 2,
  /** Form : 表单 */
  Form = 4,
  /** Header : HTTP header */
  Header = 8,
  /** Route : 路由 */
  Route = 16,
  /** Services : 服务注入 */
  Services = 32
}

/**
 * HTTP参数来源枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumHTTPParameterSourceMD {
  private static items = [
    new EnumItemMD('Query', 1, 'Query', 'URL地址参数'),
    new EnumItemMD('Body', 2, 'Body', 'HTTP Body'),
    new EnumItemMD('Form', 4, 'Form', '表单'),
    new EnumItemMD('Header', 8, 'Header', 'HTTP header'),
    new EnumItemMD('Route', 16, 'Route', '路由'),
    new EnumItemMD('Services', 32, 'Services', '服务注入')
  ];

  static getItem(enumItem: EnumHTTPParameterSource) {
    return this.items.find(item => item.name === EnumHTTPParameterSource[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
